export const SLIDEOUT_STATUS = {
  LIST: 'GradeList',
  VIEW: 'ViewGrade'
};
